import { TeacherUpdate } from '@/api/teacher'
import { GetCountryList, GetLanguageList, quickbooksRedirectionUrl, quickbookActivation, quickbooksDisconnect} from '@/api/common'
import { mapActions } from 'vuex'

export const UserSettings = {
  data () {
    return {
      countryList: [],
      languageList:[],
      redirectionUrl: ''

    }
  },
  methods:{
    ...mapActions(['SET_USER_INFO']),

    async updateGeneralSettings (payload, teacherId, customerId) {
      try {
        
        const { data } = await TeacherUpdate(payload, teacherId, customerId)
        
        if (data) {
          this.$emit('updatedData', data.data.operationalUser)
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          userInfo.picture = data.data.operationalUser.basic_details.picture
          userInfo.first_name = data.data.operationalUser.basic_details.first_name
          userInfo.last_name = data.data.operationalUser.basic_details.last_name
          localStorage.setItem('userInfo', JSON.stringify(userInfo))

          this.SET_USER_INFO(userInfo)

          this.showSuccessMessage('Success', 'Fields Updated Successfully', 'success') 

        }
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
        
      } catch (e) {
        
      }
    },
    async getLanguage () {
      try {
        const { data } = await GetLanguageList()
        const list = data.data.languages_list
        // list.map(item => {
        //   return {
        //     id:item.id,
        //     language:item.language,
        //     short_name: item.short_name
        //   }
        // })
        this.languageList = list
        
      } catch (e) {
        
      }
    },

    async redirectToQuickbook () {
      try {
        const data = await quickbooksRedirectionUrl(localStorage.getItem('customer_id'))
        this.redirectionUrl = data.data.data.auth_url
      } catch (e) {
        console.log(e)
      }
    },
    async quickbookActivation () {
      try {
        const payload = {
          customer_id: localStorage.getItem('customer_id'),
          is_enable: !this.quickBook
        }
        const data = await quickbookActivation(payload)
        this.showSuccessMessage('Success', data.data.message, 'success') 
      } catch (e) {
        console.log(e)
      }
    },

    async quickbooksDisconnect () {
      const text = 'Disconnecting...'
      this.$vs.loading({
        text
      })
      try {
        const data = await quickbooksDisconnect(localStorage.getItem('customer_id'))
        this.showSuccessMessage('Success', data.data.message, 'success') 
        this.connectedQuickbook = false
        this.$vs.loading.close()
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    }
    
  }
}